const config = {
  // for development
  // baseURL: "http://localhost/virendra/ssbackend/api",
  // imageURL: "http://localhost/virendra/ssbackend/",
  // productURL: "http://localhost/virendra/ssbackend",

  apiBaseURL: "https://checkout.razorpay.com/v1/checkout.js",
  razorpayKey: process.env.REACT_APP_RAZORPAY_KEY,
  // for vercel
  // baseURL: `${window.location.origin}/api`,
  // imageURL: `${window.location.origin}`,

  // for production
  // baseURL: "https://wsigroup.co.in/ssbackend/api",
  // imageURL: "https://wsigroup.co.in/ssbackend/",

  // for production
  baseURL: "https://supersprings.co.in/ssbackend/api",
  imageURL: "https://supersprings.co.in/ssbackend",
  productURL: "https://supersprings.co.in/ssbackend",
};

export default config;
